import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const GradeCell = ({ className, e, onClick }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''}>
      <div>{data?.grade?.name}</div>
    </td>
  );
};

export default GradeCell;
